import { render, staticRenderFns } from "./EvaluationPage.vue?vue&type=template&id=8c17eae0&scoped=true&"
import script from "./EvaluationPage.vue?vue&type=script&lang=js&"
export * from "./EvaluationPage.vue?vue&type=script&lang=js&"
import style0 from "./EvaluationPage.vue?vue&type=style&index=0&id=8c17eae0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c17eae0",
  null
  
)

export default component.exports